<p-toast></p-toast>
<p-confirmDialog #cd>
    <ng-template pTemplate="headless" let-message>
        <div class="flex flex-column align-items-center p-5 surface-overlay border-round">
            <!-- <div class="border-circle bg-primary inline-flex justify-content-center align-items-center h-6rem w-6rem">
                <i class="pi pi-question text-5xl"></i>
            </div> -->
            <span class="font-bold text-2xl block mb-2 mt-4">
                {{ message.header }}
            </span>
            <p class="mb-0">{{ message.message }}</p>
            <div class="flex align-items-center gap-2 mt-4">
                <button
                    pButton
                    label="Move"
                    (click)="cd.accept()"
                    class="w-8rem">
                </button>
                <button
                    pButton
                    label="Cancel"
                    (click)="cd.reject()"
                    class="p-button-outlined w-8rem ">
                </button>
            </div>
        </div>
    </ng-template>
</p-confirmDialog>
<p-dataView #dv [value]="tenantContacts" [loading]="loading || contactsUpdating">
    <ng-template pTemplate="header">
        <div class="flex justify-content-end gap-2">
            <p-button label="New Contact" (click)="openContactDialog()" />
            <p-button *ngIf="allowContactSelection" label="Bill All Contact" severity="info" (click)="selectContact(undefined, 'all', true)"/>
            <p-button *ngIf="allowContactSelection" label="Clear Selection" severity="warning" (click)="selectContact(undefined, 'all', false)"/>
        </div>
    </ng-template>
    <ng-template pTemplate="list" let-contacts>
        <div class="grid grid-nogutter">
            <div class="col-12" *ngFor="let contact of tenantContacts; let first = first; let index = index;">
                <ng-container
                    *ngTemplateOutlet="ContactCard;context:{contact: contact, first: first, index: index}"></ng-container>
            </div>
            <div class="col-12" *ngIf="!loading && !tenantContacts.length">
                <h3>No account(s) found.</h3>
            </div>
            <div class="col-12" *ngIf="!allowContactSelection">
                <hr />
            </div>
            <div class="field col-12" *ngIf="!allowContactSelection">
                <div class="col-12">
                    <h2>Terminate all account(s)</h2>
                </div>
                <ng-container *ngTemplateOutlet="TerminateAccount;context:{type:'cancel-all'}"></ng-container>
            </div>

            <div class="field col-12" *ngIf="terminatedTenantContacts.length && !allowContactSelection">
                <p-panel header="Terminated account(s)" [toggleable]="true" [collapsed]="true" iconPos="start">
                    <div class="col-12"
                        *ngFor="let contact of terminatedTenantContacts; let first = first; let index = index;">
                        <ng-container
                            *ngTemplateOutlet="ContactCard;context:{contact: contact, first: first, index: index}"></ng-container>
                    </div>
                </p-panel>
            </div>
            <div class="col-12">
                <hr />
            </div>
        </div>
    </ng-template>
</p-dataView>

<ng-template #ContactCard let-contact="contact" let-first="first" let-index="index">
    <div class="flex flex-column sm:flex-row sm:align-items-center p-4 gap-3"
        [ngClass]="{ 'border-top-1 surface-border': !first }">
        <div class="flex flex-row justify-content-between md:align-items-center flex-1 gap-4">
            <div class="text-lg font-medium text-900 mt-2">{{ contact.contactName }} <p-tag value="Billing Contact" severity="success" *ngIf="contact.isBillingContact"/></div>
            <div class="flex flex-column md:align-items-end gap-5">
                <div class="flex flex-row-reverse md:flex-row gap-2">
                    <p-button size="small" icon="pi pi-pen-to-square" (click)="editContact(contact)"/>
                    <p-button *ngIf="allowContactSelection" [severity]="contact?.isSelected ? 'danger' : 'success'" size="small" 
                    icon="pi pi-dollar" (click)="selectContact(contact)" [disabled]="getContactErrors(contact) != ''"/>
                </div>
            </div>
        </div>
    </div>
    <div class="grid px-4">
        <div class="col-12">
            <div class="grid">
                <div class="col-12 md:col-6 lg:3">
                    <label><b>Email :</b> {{ contact['emails'] }}</label>
                </div>
                <div class="col-12 md:col-6 lg:3">
                    <label><b>Termination Date :</b> {{ contact['terminationDates'] }}</label>
                </div>
                <div class="col-12 md:col-6 lg:3">
                    <label><b>Effective Date :</b> {{ contact['effectiveDates'] }}</label>
                </div>
                <div class="col-12 md:col-6 lg:3">
                    <label><b>Rate :</b> {{ getRateLabel(contact['rate']) }}</label>
                </div>
                <div class="col-12 md:col-6 lg:3 flex align-items-center gap-1"
                    *ngFor="let keycardInfo of contact['keycardsInfo']; let i=index">
                    <label><b>Key Card {{i+1}}:</b> {{ keycardInfo.facility_code }}/{{ keycardInfo.keycards }}</label>
                    <p-tag value="{{ keycardInfo.active_keycard ? 'Active': 'Not Active' }}"
                        [severity]="keycardInfo.active_keycard ? 'success' : 'danger'" />
                </div>
                <div class="col-12 md:col-6 lg:3 flex align-items-center gap-1"
                    *ngFor="let vehicleInfo of contact['vehiclesInfo']; let i=index">
                    <label><b>Vehicle {{i+1}}:</b> {{ vehicleInfo['plate'] }}</label>
                    <!-- <p-tag value="{{ vehicleInfo?.active ? 'Active': 'Not Active' }}"
                        [severity]="vehicleInfo?.active ? 'success' : 'danger'" /> -->
                </div>
                <div class="col-12 text-right" *ngIf="allowContactSelection && getContactErrors(contact)">
                    <p-tag value="{{ getContactErrors(contact) }}" severity="danger" />
                </div>
            </div>

        </div>
    </div>
</ng-template>

<ng-template #TerminateAccount let-type="type">
    <div class="col-12">
        <div class="grid align-items-center justify-content-center">
            <div class="col-12" [class.md:col-5]="type == 'cancel-all'">
                <div class="flex justify-content-between">
                    <p-calendar placeholder="Choose Terminate Date" [(ngModel)]="terminateAccountDate"
                        styleClass="w-full" appendTo="body" />
                    <p-button label="Terminate" class="primary-btn" (click)="terminateAccounts('date')"
                        [disabled]="!terminateAccountDate" />
                </div>
            </div>
            <div class="col text-center bold">
                OR
            </div>
            <div class="col-12" [class.md:col-5]="type == 'cancel-all'" [class.text-center]="type != 'cancel-all'">
                <p-button label="Terminate Immediately" class="primary-btn" (click)="terminateAccounts('immediate')" />
            </div>
        </div>
    </div>
</ng-template>

<p-dialog header="Update Contact Details" [(visible)]="showEditContactModal" [modal]="true"
    [breakpoints]="{ '1199px': '80vw', '992px': '90vw' }" [style]="{ width: '50vw' }" [draggable]="false"
    [resizable]="false">

    <p-messages key="edit-contact-msgs" />

    <form [formGroup]="contactFormGroup" autocomplete="off">
        <div class="grid">
            <div class="col-12">
                <div class="grid">
                    <div class="field col-12 md:col-3">
                        <label for="contactFirstName" class="label-required">First Name</label>
                        <input pInputText id="contactFirstName" formControlName="contactFirstName" class="w-full" />
                        <div *ngIf="formSubmitted && contactFormGroup.controls['contactFirstName'].errors">
                            <div class="ui-messages-error"
                                *ngIf="contactFormGroup.controls['contactFirstName'].errors?.['required']">Please enter
                                contact first name.
                            </div>
                        </div>
                    </div>
                    <div class="field col-12 md:col-3">
                        <label for="contactLastName" class="label-required">Last Name</label>
                        <input pInputText id="contactLastName" formControlName="contactLastName" class="w-full" />
                        <div *ngIf="formSubmitted && contactFormGroup.controls['contactLastName'].errors">
                            <div class="ui-messages-error"
                                *ngIf="contactFormGroup.controls['contactLastName'].errors?.['required']">Please enter
                                contact last name.
                            </div>
                        </div>
                    </div>
                    <div class="field col-12 md:col-6">
                        <label for="description">Description</label>
                        <input pInputText id="description" formControlName="description" class="w-full" />
                    </div>
                    <div class="field col-12 md:col-4">
                        <label for="phones">Phone</label>
                        <input pInputText id="phones" formControlName="phones" class="w-full" />
                    </div>
                    <div class="field col-12 md:col-2">
                        <label for="extensions">Extension</label>
                        <input pInputText id="extensions" formControlName="extensions" class="w-full" />
                    </div>
                    <div class="field col-12 md:col-6">
                        <label for="emails">Email</label>
                        <input pInputText id="emails" formControlName="emails" class="w-full" />
                    </div>
                    <div class="field col-12 md:col-6">
                        <label for="state">State</label>
                        <p-dropdown formControlName="state" [options]="states" optionLabel="name" optionValue="code"
                            styleClass="w-full" id="state" appendTo="body" />
                    </div>
                    <div class="field col-12 md:col-6">
                        <label for="contactName">Rate</label>
                        <p-dropdown [options]="tenantContactServiceInfo?.['available_invoice_items']"
                            formControlName="rate" optionLabel="description" appendTo="body" styleClass="w-full"
                            [showClear]="true">
                            <ng-template let-rate pTemplate="selectedItem">
                                <div class="flex align-items-center gap-2">
                                    <div>{{ rate.description }} ({{ rate.unitprice }})</div>
                                </div>
                            </ng-template>
                            <ng-template let-rate pTemplate="item">
                                <div class="flex align-items-center gap-2">
                                    <div>{{ rate.description }} ({{ rate.unitprice }})</div>
                                </div>
                            </ng-template>
                        </p-dropdown>
                    </div>
                    <div class="field col-12 md:col-6">
                        <label for="effectiveDates">Effective Date</label>
                        <p-calendar id="effectiveDates" formControlName="effectiveDates" styleClass="w-full"
                            appendTo="body" />
                    </div>
                    <div class="field col-12 md:col-6">
                        <label for="terminationDates">Termination Date</label>
                        <p-calendar id="terminationDates" formControlName="terminationDates" styleClass="w-full"
                            appendTo="body" />
                    </div>
                    <div class="field col-12 md:col-6" *ngIf="source == 'attendant-portal'">
                        <label for="contactName">Primary Contact</label>
                        <p-dropdown [options]="primaryContactOptions()" [(ngModel)]="primaryContact" [ngModelOptions]="{standalone: true}"
                            optionLabel="description" appendTo="body" styleClass="w-full" [showClear]="true"
                            optionDisabled="disabled">
                            <ng-template let-contact pTemplate="selectedItem">
                                <div class="flex align-items-center gap-2">
                                    <div>{{ contact.contactName }}</div>
                                </div>
                            </ng-template>
                            <ng-template let-contact pTemplate="item">
                                <div class="flex align-items-center gap-2">
                                    <div>{{ contact.contactName }}</div>
                                </div>
                            </ng-template>
                        </p-dropdown>
                        <small>Select primary contact to move All keycard(s) and vehicle(s)</small>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="tenantContactServiceInfo?.wps_active">
            <hr />
            <h2>Keycard(s)</h2>
            <div class="grid">
                <div class="col-12 grid relative" *ngFor="let keycardInfo of KeycardsInfoFormControlArray.controls; let i=index"
                    [formGroup]="getKeycardsInfoFormGroup(i)">
                    <div class="field col-12 md:col-3">
                        <label for="facility_code_{{i}}" class="label-required">Facility Code</label>
                        <input pInputText id="facility_code_{{i}}" formControlName="facility_code" class="w-full" />
                        <div class="ui-messages-error"
                            *ngIf="formSubmitted && getKeycardsInfoFormGroup(i).controls['facility_code'].errors?.['required']">
                            Please enter facility code.
                        </div>
                    </div>
                    <div class="field col-12 md:col-3">
                        <label for="keycards_{{i}}" class="label-required">Keycard</label>
                        <input pInputText id="keycards_{{i}}" formControlName="keycards" class="w-full" />
                        <div class="ui-messages-error"
                            *ngIf="formSubmitted && getKeycardsInfoFormGroup(i).controls['keycards'].errors?.['required']">
                            Please enter keycard.
                        </div>
                    </div>
                    <div class="col-12 md:col-3" *ngIf="tenantContactServiceInfo?.wps_active">
                        <div class="field-checkbox h-full">
                            <p-checkbox formControlName="active_keycard" [binary]="true"
                                inputId="active-keycard-{{i}}" [disabled]="false"></p-checkbox>
                            <label for="active-keycard-{{i}}">Active KeyCard</label>
                        </div>
                    </div>
                    <div class="field col-12 md:col-2" *ngIf="tenantContactServiceInfo?.wps_active">
                        <label for="kc-actions">Keycard Actions</label>
                        <p-dropdown id="kc-actions" [options]="availableKeycardActions"
                            formControlName="keycard_action" optionLabel="name" optionValue="code" appendTo="body" styleClass="w-full"
                            (onChange)="keycardAction($event, i)">
                        </p-dropdown>
                    </div>
                    <div class="field col-1 text-right m-auto pb-0" *ngIf="!getKeycardsInfoFormGroup(i).controls['active_keycard'].disabled">
                        <p-button severity="danger" icon="pi pi-trash" (onClick)="removeKeycardsInfoGroup(i)" />
                    </div>
                    <div *ngIf="getKeycardsInfoFormGroup(i).controls['active_keycard'].errors" class="col-12 text-right">
                        <div class="ui-messages-success absolute bottom-0 w-full"
                            *ngIf="getKeycardsInfoFormGroup(i).controls['active_keycard'].errors?.['custom_msg']">
                            {{ getKeycardsInfoFormGroup(i).controls['active_keycard'].errors?.['custom_msg'] }}
                        </div>
                        <div class="ui-messages-error absolute bottom-0 w-full"
                            *ngIf="getKeycardsInfoFormGroup(i).controls['active_keycard'].errors?.['custom_error']">
                            {{ getKeycardsInfoFormGroup(i).controls['active_keycard'].errors?.['custom_error'] }}
                        </div>
                    </div>
                </div>
                <div class="col-12 text-center" *ngIf="!contactFormGroup.controls['terminationDates'].disabled">
                    <p-button class="add-vehicle" label="{{ KeycardsInfoFormControlArray.controls.length ? 'Add Another' : 'Add' }}" [text]="true" icon="pi pi-plus" (onClick)="addKeycardsInfoGroup(false)" />
                </div>
            </div>
            <hr />
            <h2>Vehicle(s) Info</h2>
            <div class="grid">
                <div class="col-12 grid" *ngFor="let vehicleInfo of VehiclesInfoFormControlArray.controls; let i=index"
                    [formGroup]="getVehiclesInfoFormGroup(i)">
                    <div class="field col-12 sm:col-6 md:col-4">
                        <label for="plate_{{i}}" class="label-required">License Plate</label>
                        <input pInputText id="plate_{{i}}" formControlName="plate" class="w-full" />
                        <div class="ui-messages-error"
                            *ngIf="formSubmitted && getVehiclesInfoFormGroup(i).controls['plate'].errors?.['required']">
                            Please enter license number.
                        </div>
                    </div>
                    <div class="field col-12 sm:col-6 md:col-4">
                        <label for="make_{{i}}">Make</label>
                        <input pInputText id="make_{{i}}" formControlName="make" class="w-full" />
                    </div>
                    <div class="field col-12 sm:col-6 md:col-4">
                        <label for="model_{{i}}">Model</label>
                        <input pInputText id="model_{{i}}" formControlName="model" class="w-full" />
                    </div>
                    <div class="field col-12 sm:col-6 md:col-4">
                        <label for="year_{{i}}">Year</label>
                        <p-calendar id="year_{{i}}" formControlName="year" styleClass="w-full" view="year" dateFormat="yy"
                            appendTo="body"/>
                    </div>
                    <div class="field col-12 sm:col-6 md:col-4">
                        <label for="color_{{i}}">Color</label>
                        <input pInputText id="color_{{i}}" formControlName="color" class="w-full" />
                    </div>
                    <div class="field col-12 sm:col-6 md:col-4 text-right m-auto pb-0">
                        <p-button *ngIf="allowAddEditContact" severity="danger" icon="pi pi-trash" (onClick)="removeVehiclesInfoGroup(i)" />
                    </div>
                </div>
                <div class="col-12 text-center">
                    <p-button class="add-vehicle" *ngIf="allowAddEditContact"
                    label="{{ VehiclesInfoFormControlArray.controls.length ? 'Add Another' : 'Add' }}"
                        [text]="true" icon="pi pi-plus" (onClick)="addVehiclesInfoGroup()" />
                </div>
            </div>
        </div>
    </form>

    <ng-template pTemplate="footer">
        <p-button label="Cancel" [text]="true" (onClick)="closeContactDialog()" [disabled]="contactsUpdating" />
        <p-button label="Update" [loading]="contactsUpdating" (onClick)="updateContact($event, 'update')"
            *ngIf="allowAddEditContact" />
        <p-button label="Cancel Contact" severity="danger"
            *ngIf="KeycardsInfoFormControlArray.controls.length && allowAddEditContact"
            (click)="showCancelKeycardModal = true" [disabled]="contactsUpdating" />
    </ng-template>
</p-dialog>

<p-dialog header="Add Contact" [(visible)]="showAttendantAddContactModal" [modal]="true"
    [breakpoints]="{ '1199px': '80vw', '992px': '90vw' }" [style]="{ width: '50vw' }" [draggable]="false"
    [resizable]="false">

    <p-messages key="edit-contact-msgs" />

    <form [formGroup]="contactFormGroup" autocomplete="off">
        <div class="grid">
            <div class="col-12">
                <div class="grid">
                    <div class="field col-12 md:col-3">
                        <label for="contactFirstName" class="label-required">First Name</label>
                        <input pInputText id="contactFirstName" formControlName="contactFirstName" class="w-full" />
                        <div *ngIf="formSubmitted && contactFormGroup.controls['contactFirstName'].errors">
                            <div class="ui-messages-error"
                                *ngIf="contactFormGroup.controls['contactFirstName'].errors?.['required']">Please enter
                                contact first name.
                            </div>
                        </div>
                    </div>
                    <div class="field col-12 md:col-3">
                        <label for="contactLastName" class="label-required">Last Name</label>
                        <input pInputText id="contactLastName" formControlName="contactLastName" class="w-full" />
                        <div *ngIf="formSubmitted && contactFormGroup.controls['contactLastName'].errors">
                            <div class="ui-messages-error"
                                *ngIf="contactFormGroup.controls['contactLastName'].errors?.['required']">Please enter
                                contact last name.
                            </div>
                        </div>
                    </div>
                    <div class="field col-12 md:col-6">
                        <label for="description">Description</label>
                        <input pInputText id="description" formControlName="description" class="w-full" />
                    </div>
                    <div class="field col-12 md:col-4">
                        <label for="phones">Phone</label>
                        <input pInputText id="phones" formControlName="phones" class="w-full" />
                    </div>
                    <div class="field col-12 md:col-2">
                        <label for="extensions">Extension</label>
                        <input pInputText id="extensions" formControlName="extensions" class="w-full" />
                    </div>
                    <div class="field col-12 md:col-6">
                        <label for="emails">Email</label>
                        <input pInputText id="emails" formControlName="emails" class="w-full" />
                    </div>
                    <div class="field col-12 md:col-6">
                        <label for="state">State</label>
                        <p-dropdown formControlName="state" [options]="states" optionLabel="name" optionValue="code"
                            styleClass="w-full" id="state" appendTo="body" />
                    </div>
                    <div class="field col-12 md:col-3">
                        <label for="rate">Rate</label>
                        <p-dropdown [options]="tenantContactServiceInfo?.['available_invoice_items']"
                            formControlName="rate" optionLabel="description" appendTo="body" styleClass="w-full"
                            [showClear]="true">
                            <ng-template let-rate pTemplate="selectedItem">
                                <div class="flex align-items-center gap-2">
                                    <div>{{ rate.description }} ({{ rate.unitprice }})</div>
                                </div>
                            </ng-template>
                            <ng-template let-rate pTemplate="item">
                                <div class="flex align-items-center gap-2">
                                    <div>{{ rate.description }} ({{ rate.unitprice }})</div>
                                </div>
                            </ng-template>
                        </p-dropdown>
                        <div *ngIf="formSubmitted && contactFormGroup.controls['rate'].errors">
                            <div class="ui-messages-error"
                                *ngIf="contactFormGroup.controls['rate'].errors?.['required']">Please select rate.
                            </div>
                        </div>
                    </div>
                    <div class="field col-12 md:col-3">
                        <label for="ar_type">AR Type</label>
                        <p-dropdown id="ar_type" [options]="tenantContactServiceInfo?.['available_ar_types']"
                            formControlName="ar_type" optionLabel="key" optionValue="code" appendTo="body" styleClass="w-full"
                            [showClear]="true">
                        </p-dropdown>
                        <div *ngIf="formSubmitted && contactFormGroup.controls['ar_type'].errors">
                            <div class="ui-messages-error"
                                *ngIf="contactFormGroup.controls['ar_type'].errors?.['required']">Please select AR Type.
                            </div>
                        </div>
                    </div>
                    <div class="field col-12 md:col-6">
                        <label for="effectiveDates" class="label-required">Effective Date</label>
                        <p-calendar id="effectiveDates" formControlName="effectiveDates" styleClass="w-full"
                            appendTo="body" [minDate]="maxDate"/>
                    </div>
                    <div class="field col-12 md:col-6">
                        <label for="terminationDates" class="label-required">Termination Date</label>
                        <p-calendar id="terminationDates" formControlName="terminationDates" styleClass="w-full"
                            appendTo="body" [minDate]="maxDate"/>
                        <div class="ui-messages-error"
                            *ngIf="formSubmitted && contactFormGroup.controls['terminationDates'].errors?.['required']">
                            Please enter termination date.
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="tenantContactServiceInfo?.wps_active">
            <hr />
            <h2>Keycard(s)</h2>
            <div class="grid">
                <div class="col-12 grid relative" *ngFor="let keycardInfo of KeycardsInfoFormControlArray.controls; let i=index"
                    [formGroup]="getKeycardsInfoFormGroup(i)">
                    <div class="field col-12 md:col-3">
                        <label for="facility_code_{{i}}" class="label-required">Facility Code</label>
                        <input pInputText id="facility_code_{{i}}" formControlName="facility_code" class="w-full" />
                        <div class="ui-messages-error"
                            *ngIf="formSubmitted && getKeycardsInfoFormGroup(i).controls['facility_code'].errors?.['required']">
                            Please enter facility code.
                        </div>
                    </div>
                    <div class="field col-12 md:col-3">
                        <label for="keycards_{{i}}" class="label-required">Keycard</label>
                        <input pInputText id="keycards_{{i}}" formControlName="keycards" class="w-full" />
                        <div class="ui-messages-error"
                            *ngIf="formSubmitted && getKeycardsInfoFormGroup(i).controls['keycards'].errors?.['required']">
                            Please enter keycard.
                        </div>
                    </div>
                    <div class="field col-12 md:col-3" *ngIf="tenantContactServiceInfo?.wps_active">
                        <div class="field-checkbox h-full">
                            <p-checkbox formControlName="active_keycard" [binary]="true"
                                inputId="active-keycard-{{i}}"></p-checkbox>
                            <label for="active-keycard-{{i}}">Active KeyCard</label>
                        </div>
                    </div>
                    <div class="field col-12 md:col-2" *ngIf="tenantContactServiceInfo?.wps_active">
                        <label for="kc-actions">Keycard Actions</label>
                        <p-dropdown id="kc-actions" [options]="availableKeycardActions"
                            formControlName="keycard_action" optionLabel="name" optionValue="code" appendTo="body" styleClass="w-full"
                            (onChange)="keycardAction($event, i)">
                        </p-dropdown>
                    </div>
                    <div class="field col-4 sm:col text-right m-auto pb-0">
                        <p-button severity="danger" icon="pi pi-trash" (onClick)="removeKeycardsInfoGroup(i)" />
                    </div>
                    <div *ngIf="getKeycardsInfoFormGroup(i).controls['active_keycard'].errors" class="col-12 text-right">
                        <div class="ui-messages-success absolute bottom-0 w-full"
                            *ngIf="getKeycardsInfoFormGroup(i).controls['active_keycard'].errors?.['custom_msg']">
                            {{ getKeycardsInfoFormGroup(i).controls['active_keycard'].errors?.['custom_msg'] }}
                        </div>
                        <div class="ui-messages-error absolute bottom-0 w-full"
                            *ngIf="getKeycardsInfoFormGroup(i).controls['active_keycard'].errors?.['custom_error']">
                            {{ getKeycardsInfoFormGroup(i).controls['active_keycard'].errors?.['custom_error'] }}
                        </div>
                    </div>
                </div>
                <div class="col-12 text-center">
                    <p-button class="add-vehicle" label="{{ KeycardsInfoFormControlArray.controls.length ? 'Add Another' : 'Add' }}" [text]="true" icon="pi pi-plus" (onClick)="addKeycardsInfoGroup(false)" />
                </div>
            </div>
            <hr />
            <h2>Vehicle(s) Info</h2>
            <div class="grid">
                <div class="col-12 grid" *ngFor="let vehicleInfo of VehiclesInfoFormControlArray.controls; let i=index"
                    [formGroup]="getVehiclesInfoFormGroup(i)">
                    <div class="field col-12 md:col-4">
                        <label for="plate_{{i}}" class="label-required">License Plate</label>
                        <input pInputText id="plate_{{i}}" formControlName="plate" class="w-full" />
                        <div class="ui-messages-error"
                            *ngIf="formSubmitted && getVehiclesInfoFormGroup(i).controls['plate'].errors?.['required']">
                            Please enter license number.
                        </div>
                    </div>
                    <div class="field col-12 sm:col-6 md:col-4">
                        <label for="make_{{i}}">Make</label>
                        <input pInputText id="make_{{i}}" formControlName="make" class="w-full" />
                    </div>
                    <div class="field col-12 sm:col-6 md:col-4">
                        <label for="model_{{i}}">Model</label>
                        <input pInputText id="model_{{i}}" formControlName="model" class="w-full" />
                    </div>
                    <div class="field col-12 sm:col-6 md:col-4">
                        <label for="year_{{i}}">Year</label>
                        <p-calendar id="year_{{i}}" formControlName="year" styleClass="w-full" view="year" dateFormat="yy"
                            appendTo="body"/>
                    </div>
                    <div class="field col-12 sm:col-6 md:col-4">
                        <label for="color_{{i}}">Color</label>
                        <input pInputText id="color_{{i}}" formControlName="color" class="w-full" />
                    </div>
                    <div class="field col-12 sm:col-6 md:col-4 text-right m-auto pb-0">
                        <p-button severity="danger" icon="pi pi-trash" (onClick)="removeVehiclesInfoGroup(i)" />
                    </div>
                </div>
                <div class="col-12 text-center">
                    <p-button class="add-vehicle"
                    label="{{ VehiclesInfoFormControlArray.controls.length ? 'Add Another' : 'Add' }}"
                        [text]="true" icon="pi pi-plus" (onClick)="addVehiclesInfoGroup()" />
                </div>
            </div>
        </div>
    </form>

    <ng-template pTemplate="footer">
        <div class="flex justify-content-between">
            <div>
                <p-button label="SUREPARK Integration Enabled" [text]="true" *ngIf="tenantContactServiceInfo?.wps_active"/>
                <p-button label="DEV Autofill" severity="warning" [text]="true" icon="pi pi-pencil" (onClick)="devAutofillForm()" class="ml-2" />
            </div>
            <div>
                <p-button label="Cancel" [text]="true" (onClick)="closeContactDialog()" [disabled]="contactsUpdating" />
                <p-button label="Create Contact" [loading]="contactsUpdating" (onClick)="updateContact($event, 'create')"/>
            </div>
        </div>
    </ng-template>
</p-dialog>

<p-dialog header="Create New Contact" [(visible)]="showContactModal" [modal]="true" [breakpoints]="{ '1199px': '80vw', '992px': '90vw', '575px': '99vw' }"
    [style]="{ width: '50vw' }" [closable]="false" [draggable]="false" [resizable]="false" styleClass="steps-dialog">
    <p-stepper [linear]="true" [activeStep]="currentStepIndex">
        <p-stepperPanel header="Add Contact Detalis">
            <ng-template pTemplate="content" let-nextCallback="nextCallback" let-index="index">
                <div class="col-12">
                    <p-messages key="disable-payment-msg" />
                    <p-messages key="edit-contact-msgs" />
                </div>
                <div class="col-12">
                    Please enter the information about the person being added to the account.
                  </div>
                <div class="col-12">
                    <form [formGroup]="contactFormGroup" autocomplete="off">
                        <div class="grid">
                            <div class="col-12">
                                <div class="grid">
                                    <div class="field col-12 md:col-3">
                                        <label for="contactFirstName" class="label-required">First Name</label>
                                        <input pInputText id="contactFirstName" formControlName="contactFirstName"
                                            class="w-full" />
                                        <div
                                            *ngIf="formSubmitted && contactFormGroup.controls['contactFirstName'].errors">
                                            <div class="ui-messages-error"
                                                *ngIf="contactFormGroup.controls['contactFirstName'].errors?.['required']">
                                                Please enter
                                                contact first name.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="field col-12 md:col-3">
                                        <label for="contactLastName" class="label-required">Last Name</label>
                                        <input pInputText id="contactLastName" formControlName="contactLastName"
                                            class="w-full" />
                                        <div
                                            *ngIf="formSubmitted && contactFormGroup.controls['contactLastName'].errors">
                                            <div class="ui-messages-error"
                                                *ngIf="contactFormGroup.controls['contactLastName'].errors?.['required']">
                                                Please enter
                                                contact last name.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="field col-12 md:col-6">
                                        <label for="description">Description</label>
                                        <input pInputText id="description" formControlName="description"
                                            class="w-full" />
                                    </div>
                                    <div class="field col-12 md:col-4">
                                        <label for="phones">Phone</label>
                                        <input pInputText id="phones" formControlName="phones" class="w-full" />
                                    </div>
                                    <div class="field col-12 md:col-2">
                                        <label for="extensions">Extension</label>
                                        <input pInputText id="extensions" formControlName="extensions" class="w-full" />
                                    </div>
                                    <div class="field col-12 md:col-6">
                                        <label for="emails">Email</label>
                                        <input pInputText id="emails" formControlName="emails" class="w-full" />
                                    </div>
                                    <div class="field col-12 md:col-4">
                                        <label for="state">State</label>
                                        <p-dropdown formControlName="state" [options]="states" optionLabel="name"
                                            optionValue="code" styleClass="w-full" id="state" appendTo="body" />
                                    </div>
                                    <div class="field col-12 md:col-4">
                                        <label for="rate" class="label-required">Rate</label>
                                        <p-dropdown [options]="tenantContactServiceInfo?.['available_invoice_items']"
                                            formControlName="rate" optionLabel="description" appendTo="body"
                                            styleClass="w-full" [showClear]="true">
                                            <ng-template let-rate pTemplate="selectedItem">
                                                <div class="flex align-items-center gap-2">
                                                    <div>{{ rate.description }} ({{ rate.unitprice }})</div>
                                                </div>
                                            </ng-template>
                                            <ng-template let-rate pTemplate="item">
                                                <div class="flex align-items-center gap-2">
                                                    <div>{{ rate.description }} ({{ rate.unitprice }})</div>
                                                </div>
                                            </ng-template>
                                        </p-dropdown>
                                        <div *ngIf="formSubmitted && contactFormGroup.controls['rate'].errors">
                                            <div class="ui-messages-error"
                                                *ngIf="contactFormGroup.controls['rate'].errors?.['required']">
                                                Please select rate.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="field col-12 md:col-4">
                                        <label for="effectiveDates">Effective Date</label>
                                        <p-calendar id="effectiveDates" formControlName="effectiveDates"
                                            styleClass="w-full" appendTo="body"
                                            [minDate]="maxDate" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <h2>Vehicle(s) Info</h2>
                        <div class="grid">
                            <div class="col-12 grid"
                                *ngFor="let vehicleInfo of VehiclesInfoFormControlArray.controls; let i=index"
                                [formGroup]="getVehiclesInfoFormGroup(i)">
                                <div class="field col-12 md:col-4">
                                    <label for="plate_{{i}}" class="label-required">License Plate</label>
                                    <input pInputText id="plate_{{i}}" formControlName="plate" class="w-full" />
                                    <div class="ui-messages-error"
                                        *ngIf="formSubmitted && getVehiclesInfoFormGroup(i).controls['plate'].errors?.['required']">
                                        Please enter license number.
                                    </div>
                                </div>
                                <div class="field col-12 sm:col-6 md:col-4">
                                    <label for="make_{{i}}">Make</label>
                                    <input pInputText id="make_{{i}}" formControlName="make" class="w-full" />
                                </div>
                                <div class="field col-12 sm:col-6 md:col-4">
                                    <label for="model_{{i}}">Model</label>
                                    <input pInputText id="model_{{i}}" formControlName="model" class="w-full" />
                                </div>
                                <div class="field col-12 sm:col-6 md:col-4">
                                    <label for="year_{{i}}">Year</label>
                                    <p-calendar id="year_{{i}}" formControlName="year" styleClass="w-full" view="year"
                                        dateFormat="yy" appendTo="body"/>
                                </div>
                                <div class="field col-12 sm:col-6 md:col-4">
                                    <label for="color_{{i}}">Color</label>
                                    <input pInputText id="color_{{i}}" formControlName="color" class="w-full" />
                                </div>
                                <div class="field col-12 sm:col-6 md:col-4 text-right m-auto pb-0">
                                    <p-button severity="danger" icon="pi pi-trash"
                                        (onClick)="removeVehiclesInfoGroup(i)" />
                                </div>
                            </div>
                            <div class="col-12 text-center" *ngIf="VehiclesInfoFormControlArray.controls.length < allowedVehicles">
                                <p-button
                                    class="add-vehicle"
                                    label="{{ VehiclesInfoFormControlArray.controls.length ? 'Add Another' : 'Add' }}"
                                    [text]="true" icon="pi pi-plus" (onClick)="addVehiclesInfoGroup()" />
                            </div>
                        </div>
                    </form>
                </div>
            </ng-template>
        </p-stepperPanel>
        <p-stepperPanel header="Payment">
            <ng-template pTemplate="content" let-nextCallback="nextCallback" let-index="index">
                <div class="col-12">
                    <p>If you do not wish to make a payment now please contact your parking attendant to setup the new
                        contact.</p>
                </div>
                <div class="col-12">
                    <payment-method-selection [tokenizationSourceKey]="tokenizationSourceKey" (paymentMethodSelectedEvent)="paymentMethodSelected($event)" [AllowCheckMethod]="autopaySettings?.cpp_echeck_payment_enabled" [isPaymentEnabled]="autopaySettings?.cpp_payment_enabled" module="parking-change"></payment-method-selection>
                </div>
            </ng-template>
        </p-stepperPanel>
        <p-stepperPanel header="Activation Fee">
            <ng-template pTemplate="content" let-nextCallback="nextCallback" let-index="index">
                <div class="col-12">
                    <p *ngIf="autopaySettings?.cpp_payment_enabled">Adding new contact keycard requires an activation fee to be paid.</p>
                    <p *ngIf="!autopaySettings?.cpp_payment_enabled">An activation fee is required for all newly activated keycards. This fee must be paid when the keycard is picked up so please be prepared to pay for the activation fee when collecting the keycard from the attendant.</p>
                </div>
                <div class="col-12">
                    <payment-method-selection [tokenizationSourceKey]="tokenizationSourceKey" (paymentMethodSelectedEvent)="paymentMethodSelected($event)" [AllowCheckMethod]="autopaySettings?.cpp_echeck_payment_enabled" module="parking-change" [NotAllowedACHMethod]="true" [isPaymentEnabled]="autopaySettings?.cpp_payment_enabled"></payment-method-selection>
                </div>
            </ng-template>
        </p-stepperPanel>
        <p-stepperPanel header="Confirmation">
            <ng-template pTemplate="content" let-nextCallback="nextCallback" let-index="index">
                <div class="col-12">
                    <p-messages key="confirm-message" />
                </div>
            </ng-template>
        </p-stepperPanel>
    </p-stepper>

    <ng-template pTemplate="footer">
        <div *ngIf="currentStepIndex === 0">
            <p-button label="Cancel" (onClick)="closeContactDialog()" />
            <p-button label="Next" (onClick)="goToPaymentStep()" [disabled]="!validPaymentSettings || !activationFeesRateDescription" [loading]="validatingVehicleInfo"/>
        </div>
        <div *ngIf="currentStepIndex === 1" class="grid md:px-5">
            <div class="col-12 md:col-8">
                <div class="flex align-items-center justify-content-start text-center gap-2">
                    <p style="color: #0088cc;" class="text-sm lg:text-base">
                        <b>{{ getTotalAmount(contactFormGroup.value['rate']['unitprice']) | currency }} sub total + {{
                            getServiceCharge(contactFormGroup.value['rate']['unitprice']) | currency }} ({{ serviceChargeAmount }}%)
                            service charge</b>
                        <b>= Total {{ getTotalAmount(contactFormGroup.value['rate']['unitprice'], true) | currency }} <span
                                style="color: #22c55e;margin-left: 5px;" *ngIf="isProrated"> (Prorated)</span> <p-button icon="pi pi-info" [rounded]="true" severity="info" styleClass="parking-request-info"
                        [pTooltip]="tooltipContent" tooltipPosition="bottom"></p-button>
                        <span *ngIf="selectedPaymentMethod?.name != 'Bill Me'">
                            <br /> + <br /> {{ getTotalActivationFeesAmount(activationFeesRateDescription!.unitprice, true) | currency }} Activation fees + {{
                            getServiceCharge(activationFeesRateDescription!.unitprice, false) | currency }} ({{ serviceChargeAmount }}%) service charge
                            = Total {{ getTotalAmount(activationFeesRateDescription!.unitprice, true, false) | currency }}
                        </span></b>
                    </p>
                    <ng-template #tooltipContent>
                        <div> <b>1st and the 16th</b> Full Amount + Service Charge</div>
                        <div> <b>After 16th</b> Half Amount + Service Charge </div>
                    </ng-template>
                </div>
            </div>
            <div class="col-12 md:col-4 flex align-items-center justify-content-between sm:justify-content-end">
                <p-button label="Back" (onClick)="goToContactStep()" [loading]="paymentInProgress" />
                <p-button [label]="selectedPaymentMethod?.name == 'Bill Me' ? 'Next' : (selectedPaymentMethod ? 'Pay' : 'Save & Pay')" (onClick)="goToActivatationFeeStep()"
                    [loading]="paymentInProgress" />
            </div>
        </div>
        <div *ngIf="currentStepIndex === 2" class="grid md:px-5">
            <div class="col-12 md:col-8" *ngIf="activationFeesRateDescription">
                <div class="flex align-items-center justify-content-start text-center gap-2">
                    <p style="color: #0088cc;" class="text-sm lg:text-base">
                        <b>{{ getTotalAmount(activationFeesRateDescription['unitprice'], false, false) | currency }} sub total + {{ getServiceCharge(activationFeesRateDescription['unitprice'], false) | currency }} ({{ serviceChargeAmount }}%) service charge</b>
                        <b>= Total {{ getTotalAmount(activationFeesRateDescription['unitprice'], true, false) | currency }}</b>
                    </p>
                </div>
            </div>
            <div class="col-12 md:col-4 flex align-items-center justify-content-between sm:justify-content-end">
                <p-button label="Back" (onClick)="goToPaymentStep()" [loading]="paymentInProgress" />
                <p-button [label]="selectedPaymentMethod ? 'Pay' : 'Save & Pay'" (onClick)="processPayment()" [loading]="paymentInProgress" />
            </div>
        </div>
        <div *ngIf="currentStepIndex === 3">
            <p-button label="Close" (onClick)="closeContactDialog()" />
        </div>
    </ng-template>
</p-dialog>

<p-dialog header="Cancel Contact" [(visible)]="showCancelKeycardModal" [modal]="true" [draggable]="false"
    [resizable]="false" [breakpoints]="{ '1199px': '50vw', '992px': '70vw' }" [focusOnShow]="false">
    <div class="grid">
        <ng-container *ngTemplateOutlet="TerminateAccount"></ng-container>
    </div>
    <p class="font-italic">'Terminate' or 'Terminate Immidiatly' will teminate all keycards for this contact.</p>
</p-dialog>

<!-- Debug Panel - JSON View of tenantContacts -->
<!--<p-panel header="Debug: tenantContacts JSON" styleClass="mt-3" class="w-full" [toggleable]="true" [collapsed]="true">-->
<!--    <pre style="word-break: break-all;white-space: break-spaces">{{ tenantContacts | json }}</pre>-->
<!--</p-panel>-->

